import { browserApi } from 'lib/httpClient';

export type EvPageFeature = {
  timestamp: number;
  features: {
    'show-debug-dev': {
      defaultValue: boolean;
    };
  };
  dateUpdated: Date;
};

async function getFeatures(): Promise<EvPageFeature> {
  try {
    const { data } = await browserApi.get(process.env.NEXT_PUBLIC_URL_GROWTHBOOK_SERVICE as string, {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_GROWTHBOOK_TOKEN,
      },
    });
    const features: EvPageFeature = {
      timestamp: data?.timestamp,
      features: data?.features,
      dateUpdated: new Date(data?.dateUpdated),
    };
    return features;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao buscar features:', error);
    throw error;
  }
}

export default getFeatures;
